import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage';
import TestaCollo from './pages/mobilePages/TestaCollo';
import Spalla from './pages/mobilePages/Spalla';
import Ginocchio from './pages/mobilePages/Ginocchio';
import AncaBacino from './pages/mobilePages/AncaBacino';
import CavigliaPiede from './pages/mobilePages/CavigliaPiede';
import Schiena from './pages/mobilePages/Schiena';
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
import PatologieTrattamenti from './pages/PatologieTrattamenti';
import Team from './pages/Team';
import Tecnologie from './pages/Tecnologie';
import Formazione from './pages/Formazione';
import Servizi from './pages/Servizi';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiePolicy from './pages/CookiePolicy';
import Seo from './components/Seo';
import NotFound from './pages/notfound/NotFound';
import MainLayout from './layout/MainLayout';
import LandingSport from './pages/LandingSport';
AOS.init();


function App() {

  return (
    <div className="App">
      <Router>
        <Seo />

        <Routes>
          <Route element={<MainLayout />}>
            {/* MOBILE */}
            <Route exact path="/testa-collo/" element={<TestaCollo />} />
            <Route exact path="/spalla/" element={<Spalla />} />
            <Route exact path="/ginocchio/" element={<Ginocchio />} />
            <Route exact path="/anca-bacino/" element={<AncaBacino />} />
            <Route exact path="/caviglia-piede/" element={<CavigliaPiede />} />
            <Route exact path="/schiena/" element={<Schiena />} />
            {/* /MOBILE */}

            <Route exact path="/" element={<HomePage />} />
            <Route exact path="/fisioterapia/" element={<PatologieTrattamenti />} />
            <Route exact path="/staff/" element={<Team />} />
            <Route exact path="/tecnologie/" element={<Tecnologie />} />
            <Route exact path="/formazione/" element={<Formazione />} />
            <Route exact path="/servizi/" element={<Servizi />} />
            <Route exact path="/torna-alla-tua-performance/" element={<LandingSport />} />
            <Route exact path="/privacypolicy/" element={<PrivacyPolicy />} />
            <Route exact path="/cookie-policy/" element={<CookiePolicy />} />
          </Route>
          
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
